import React, { useContext, useEffect, useState } from "react";
import Form from "react-bootstrap/Form";
import ic_bell_green from "../assets/images/ic_bell_green.svg";
import ic_account_green from "../assets/images/ic_account_green.svg";
import ic_bag_green from "../assets/images/ic_bag_green.svg";
import ic_bell_light from "../assets/images/ic_bell_light.svg";
import ic_account_light from "../assets/images/ic_account_light.svg";
import ic_bag_light from "../assets/images/ic_bag_light.svg";
import ic_search_green from "../assets/images/ic_search_green.svg";
import Dropdown from "react-bootstrap/Dropdown";
import { Link, useNavigate } from "react-router-dom";

import ic_ac_setting from "../assets/images/ic_ac_setting.png";
import ic_logout from "../assets/images/ic_logout.svg";
import user_img from "../assets/images/user_img.png";
import dummyProfile from "../assets/images/dummyProfile.webp";
import ic_req_ambulance from "../assets/images/ic_req_ambulance.svg";
import Logo from "../assets/images/logo-black.png";
import { simpleGetCall } from "../api/ApiServices";
import ApiConfig from "../api/ApiConfig";
import { AppContext } from "../context/AppContext";
import { FiSearch } from "react-icons/fi";
const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const navigate = useNavigate();

  const handleScroll = () => {
    if (window.scrollY > 20) {
      setScrolled(true);
    } else {
      setScrolled(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const {
    storesList,
    setSelectedStore,
    selectedStore,
    restaurantGeofenceRadiusKm,
    set_selected_location,
    setRestaurantGeofenceRadiusKm,
    setRestaurantDetails,
    setStoresList,
    setSearchTerm,
    searchTerm,
  } = useContext(AppContext);

  const handleLogOut = () => {
    set_selected_location([]);
    setRestaurantDetails(null);
    setStoresList([]);
    setSelectedStore(null);
    setRestaurantGeofenceRadiusKm(6);
    localStorage.clear();

    navigate("/");
  };

  const formattedStores =
    storesList?.length > 0
      ? storesList.map((store) => ({
          value: store.value,
          label: store.label,
          id: store.id,
        }))
      : [];

  const selectedStoreObj = storesList.find(
    (store) => store.value == selectedStore
  );
  const Data = JSON.parse(localStorage.getItem("LOGIN_DATA"));

  // following code for serviceticker working
  const [selectedStroeObject, setSelectedStoreObject] =
    useState(selectedStoreObj);
  console.log("selectedStroeObject ===>", selectedStroeObject);

  function getSelectedStore(selectedStore, storeList) {
    if (!Array.isArray(storeList) || typeof selectedStore !== "number") {
      console.error("Invalid input: expected (number, array)");
      return null;
    }

    const foundStore = storeList.find(
      (store) => store.value === selectedStore || store.id === selectedStore
    );
    return foundStore || null;
  }

  //

  return (
    <div className="cx-header-wrapper">
      <div
        className={
          scrolled
            ? " scrollActive header-bottom-section"
            : "header-bottom-section"
        }
      >
        <div className="first">
          <div className="logo-wrapper">
            <Link to="/Home">
              <img src={Logo} alt="" />
            </Link>
            {/* <label htmlFor="">Your Logo</label> */}
          </div>
        </div>

        {(window.location.pathname == "/Home" ||
          window.location.hash == "#/Home") && (
          <div className="second">
            <div className="search-select-wrapper">
              <Form.Select
                aria-label="Select Restaurant"
                value={selectedStore}
                onChange={(e) => {
                  localStorage.setItem("selectedStore", e.target.value);
                  setSelectedStore(e.target.value);
                }}
              >
                {/* <option value="">Select a Restaurant</option> */}
                {storesList.map((store) => (
                  <option
                    // disabled={store.store_status == 0 || parseFloat(store?.Distance?.distanceInKm)?.toFixed(2)>restaurantGeofenceRadiusKm}
                    key={store.id}
                    value={store.value}
                  >
                    {store.label}
                    {store.store_status == 0
                      ? `- (Online service is not currently available)`
                      : parseFloat(store?.Distance?.distanceInKm)?.toFixed(2) >
                        restaurantGeofenceRadiusKm
                      ? "-(Service not available at your current location)"
                      : ""}
                  </option>
                ))}
              </Form.Select>
              <div style={{ position: "relative" }}>
                <Form.Control
                  type="text"
                  placeholder="Search Here .."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
                <FiSearch
                  style={{
                    position: "absolute",
                    top: "50%",
                    right: "12px",
                    transform: "translateY(-50%)",
                    color: "#888",
                    cursor: "pointer",
                  }}
                />
              </div>
            </div>
          </div>
        )}

        <div className="third">
          <Dropdown>
            <Dropdown.Toggle id="dropdown-basic">
              <div className="my-ac-wrapper" id="dropdown-basic">
                {scrolled ? (
                  <img src={ic_account_green} alt="" />
                ) : (
                  <img src={ic_account_green} alt="" />
                )}

                <label htmlFor="" className="mb-0">My Account</label>
              </div>
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <div className="name-img-user">
                <div className="left">
                  <img
                    src={
                      JSON.parse(
                        localStorage.getItem("user_profile_img_url")
                      ) &&
                      JSON.parse(
                        localStorage.getItem("user_profile_img_url") != "null"
                      ) &&
                      JSON.parse(
                        localStorage.getItem("user_profile_img_url") !=
                          undefined
                      )
                        ? ApiConfig?.BASE_URL +
                          "/" +
                          JSON.parse(
                            localStorage.getItem("user_profile_img_url")
                          )
                        : dummyProfile
                    }
                    alt="profile"
                    onError={(e) => {
                      // e.target.onerror = null; // prevents infinite loop
                      e.target.src = { dummyProfile }; // your default image path
                    }}
                  />
                </div>
                <div className="right">
                  <label htmlFor="" className="name">
                    {Data?.first_name}
                  </label>
                  {/* <p className="animal-name">Dog ,Cat</p> */}
                </div>
              </div>
              <div className="menu">
                <Dropdown.Item as={Link} to="/ProfileSetting">
                  <img src={ic_ac_setting} />
                  Account Settings
                </Dropdown.Item>
              </div>

              <div className="menu" id="logout" onClick={handleLogOut}>
                <Link to="/">
                  <img src={ic_logout} alt="" />
                  Logout
                </Link>
              </div>
            </Dropdown.Menu>
          </Dropdown>
          <div className="nav-divider" />

          <Link to="Cart" style={{ textDecoration: "none", color: "inherit" }}>
            <div className="my-blog-wrapper">
              <div className="img-badg">
                {scrolled ? (
                  <img src={ic_bag_green} alt="" />
                ) : (
                  <img src={ic_bag_green} alt="" />
                )}
              </div>
              <label className="mb-0">My Cart</label>
            </div>
          </Link>

          <div className="nav-divider" />

          <div className="bell-wrapper">
            <Link to="/Notification">
              <div className="img-badg">
                {scrolled ? (
                  <img src={ic_bell_green} alt="" />
                ) : (
                  <img src={ic_bell_green} alt="" />
                )}
              </div>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
